const ITEMS = [
  "Sonic Architecture",
  "Cinematic Worldbuilding",
  "Analog Warmth",
  "Poetic Lyricism",
  "Dark Fantasy Realms",
  "Film Direction",
  "Jazz-Hop Rhythms",
  "VHS Textures",
];

const Diamond = () => (
  <svg width="9" height="9" viewBox="0 0 10 10" aria-hidden="true" className="shrink-0">
    <rect x="2.2" y="2.2" width="5.6" height="5.6" transform="rotate(45 5 5)" fill="#C18C3D" opacity="0.8" />
  </svg>
);

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-cream/10 bg-surface py-6 overflow-hidden">
      <div className="marquee-track flex w-max items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif italic font-light text-2xl md:text-3xl text-cream/45 whitespace-nowrap hover:text-gold transition-colors duration-500">
                  {item}
                </span>
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
